import { Badge, Group, Stack, Table, TextInput } from "@mantine/core"

import {
  returnRegexMatches,
  validateRegex,
} from "@costory/front/pages/VirtualDimensions/components/AutoSplit/utils"

export const TableMappingIdentityRegex = ({
  selectedDatasourceMetrics,
  mappingType,
  regexValue,
  setRegexValue,
}: {
  selectedDatasourceMetrics: { name: string }[]
  mappingType: "regexMapping" | "identity"
  regexValue: string
  setRegexValue: (value: string) => void
}) => {
  const regexMatches = returnRegexMatches(regexValue, selectedDatasourceMetrics)
  return (
    <>
      <Stack>
        {mappingType === "regexMapping" && (
          <Group justify="space-between">
            <TextInput
              value={regexValue}
              onChange={(e) => setRegexValue(e.target.value)}
              error={validateRegex(regexValue)}
              autoComplete="regex"
              w="40%"
            />
            {regexMatches.filter((a) => !a).length > 0 && (
              <Badge color="red" variant="light">
                {regexMatches.filter((a) => a).length} matches
              </Badge>
            )}
            {regexMatches && regexMatches.filter((a) => a).length > 0 && (
              <Badge color="green" variant="light">
                {regexMatches.filter((a) => a).length} matches
              </Badge>
            )}
          </Group>
        )}
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Metric Dimension</Table.Th>
              <Table.Th>Virtual Dimension Value</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {selectedDatasourceMetrics.slice(0, 20).map((metric) => (
              <Table.Tr key={metric.name}>
                <Table.Td>{metric.name}</Table.Td>
                <Table.Td>
                  {mappingType === "identity"
                    ? metric.name
                    : regexValue && !validateRegex(regexValue)
                      ? metric.name.match(new RegExp(regexValue))?.[1] || (
                          <Badge color="red" variant="light">
                            No Match
                          </Badge>
                        )
                      : metric.name}
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Stack>
    </>
  )
}
